const pageNameKey = "machinesCancelRequestCrossModal";

export const machinesCancelRequestCrossModalEn = {
  [pageNameKey]: {
    title: "Disconnect Support Technician",
    message:
      "Are you sure you want to forcefully disconnect the support technician from this machine?",
    confirmButton: "Disconnect Technician",
    cancelButton: "Cancel",
  },
};

export const machinesCancelRequestCrossModalPtBr = {
  [pageNameKey]: {
    title: "Desconectar técnico de suporte",
    message:
      "Tem certeza de que deseja desconectar à força o técnico de suporte desta máquina?",
    confirmButton: "Desconectar técnico",
    cancelButton: "Cancelar",
  },
};

export const machinesCancelRequestCrossModalDe = {
  [pageNameKey]: {
    title: "Support-Techniker trennen",
    message:
      "Möchten Sie den Support-Techniker wirklich zwangsweise von dieser Maschine trennen?",
    confirmButton: "Techniker trennen",
    cancelButton: "Abbrechen",
  },
};

export const machinesCancelRequestCrossModalZhHans = {
  [pageNameKey]: {
    title: "断开支持技术员连接",
    message: "您确定要强制断开该机器上的支持技术员连接吗？",
    confirmButton: "断开技术员",
    cancelButton: "取消",
  },
};

export const machinesCancelRequestCrossModalIt = {
  [pageNameKey]: {
    title: "Disconnetti tecnico di supporto",
    message:
      "Sei sicuro di voler disconnettere forzatamente il tecnico di supporto da questa macchina?",
    confirmButton: "Disconnetti tecnico",
    cancelButton: "Annulla",
  },
};

export const machinesCancelRequestCrossModalEs = {
  [pageNameKey]: {
    title: "Desconectar al técnico de soporte",
    message:
      "¿Está seguro de que desea desconectar por la fuerza al técnico de soporte de esta máquina?",
    confirmButton: "Desconectar técnico",
    cancelButton: "Cancelar",
  },
};

export const machinesCancelRequestCrossModalNl = {
  [pageNameKey]: {
    cancelButton: "Annuleren",
    confirmButton: "Monteur Verbinding verbreken",
    message:
      "Wilt u de supporttechnicus echt geforceerd Verbinding verbreken van deze machine?",
    title: "Ondersteuningsmonteur Verbinding verbreken",
  },
};

export const machinesCancelRequestCrossModalTr = {
  [pageNameKey]: {
    cancelButton: "İptal etmek",
    confirmButton: "Bağlantıyı Kes Teknisyeni",
    message:
      "Destek teknisyeninin bu makineyle olan bağlantısını zorla kesmek istediğinizden emin misiniz?",
    title: "Destek Teknisyeninin Bağlantısını Kes",
  },
};
